import { navLinks } from "@/mocks/home";

const categoryLinks = [
  { label: "网红商业档案", href: "#collections" },
  { label: "网络热点复盘", href: "#collections" },
  { label: "品牌危机档案", href: "#collections" },
  { label: "直播圈观察", href: "#collections" },
  { label: "海外社媒趣闻", href: "#collections" },
  { label: "素人争议合集", href: "#collections" },
];

const helperLinks = [
  { label: "收录说明", href: "#sources" },
  { label: "标签规则", href: "#tags" },
  { label: "来源标注方式", href: "#sources" },
  { label: "归档下载指引", href: "#download" },
  { label: "更新日志", href: "#latest" },
];

export default function Footer() {
  return (
    <footer className="w-full border-t border-background-200/80 bg-background-100">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-archive-2-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">黑料91</span>
            </div>
            <p className="mt-4 max-w-xs text-xs leading-relaxed text-foreground-600">
              黑料91黑料仓库按主题、标签和来源集中收纳分散内容，顺着目录或关键词查找更快，适合想一次性整理某类内容的读者。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-github-line", "ri-mail-line", "ri-rss-line", "ri-share-forward-line"].map(
                (icon) => (
                  <a
                    key={icon}
                    href="#top"
                    className="flex h-8 w-8 items-center justify-center rounded-md border border-background-300 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer"
                  >
                    <i className={`${icon} text-base`} />
                  </a>
                ),
              )}
            </div>
          </div>

          <div>
            <h4 className="flex items-center gap-2 text-sm font-semibold text-foreground-950">
              <a href="#top" className="transition-colors hover:text-primary-600">
                站内导航
              </a>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-xs text-foreground-600 transition-colors hover:text-primary-600 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="flex items-center gap-2 text-sm font-semibold text-foreground-950">
              <a href="#collections" className="transition-colors hover:text-primary-600">
                热门合集
              </a>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {categoryLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-xs text-foreground-600 transition-colors hover:text-primary-600 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="flex items-center gap-2 text-sm font-semibold text-foreground-950">
              <a href="#sources" className="transition-colors hover:text-primary-600">
                帮助与说明
              </a>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {helperLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-xs text-foreground-600 transition-colors hover:text-primary-600 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200/80 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © 2026 黑料91黑料仓库 · 页面内容为整理归档展示，仅作目录索引参考
          </p>
          <p className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-shield-check-line text-secondary-600" />
              来源均已标注
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line text-primary-500" />
              最近更新 2026-09-10
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
}